import { format, isValid, parse } from "date-fns"

// Normalize incoming birthday into dd.MM.yyyy so the calendar parses and preselects correctly
// Handles: dd.MM.yyyy, MM/dd/yyyy, yyyy-MM-dd (date-only), and ISO strings by stripping time part to avoid TZ shifts
export const normalizeBirthday = (val?: string) => {
  if (!val) return ""

  // Trim spaces
  const raw = String(val).trim()

  const tryParse = (value: string, fmt: string) => {
    const d = parse(value, fmt, new Date())
    return isValid(d) ? d : null
  }

  // 1) Common UI formats
  let d =
    tryParse(raw, "dd.MM.yyyy") ||
    tryParse(raw, "MM/dd/yyyy") ||
    // 2) API date-only format (no time => no timezone shift)
    tryParse(raw, "yyyy-MM-dd")

  // 3) ISO strings like 1990-05-06T00:00:00Z or 1990-05-06T00:00:00+00:00
  if (!d && /T\d{2}:\d{2}:\d{2}/.test(raw)) {
    const dateOnly = raw.split("T")[0]
    d = tryParse(dateOnly, "yyyy-MM-dd")
  }

  // 4) Final fallback: Date constructor, but still guard invalid
  if (!d) {
    const d2 = new Date(raw)
    d = isValid(d2) ? d2 : null
  }

  return d ? format(d, "dd.MM.yyyy") : ""
}
